import React, { Fragment, useEffect, useState } from 'react';
import { Button, Container, Row, Form, Col, Table, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { serviceGetBancos, serviceGetDetalle } from '../../../../../api/api-cierre-gestion-defenza';
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { formato_monto } from '../../../../../common/Formatos'

const DestinatarioPago = ({ cfg_form, formik, involucrado, destinatariosPago, setDestinatariosPago, montoTotalReserva, fechaSiniestro }) => {
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const { llaves } = data_gestion_defensa;
    const [destinatarios, setDestinatarios] = useState([]);
    const [parentescos, setParentescos] = useState([]);
    const [mediosPago, setMediosPago] = useState([]);
    const [tipoCuentas, setTipoCuentas] = useState([]);
    const [bancos, setBancos] = useState([]);
    const [editIndex, setEditIndex] = useState(null)
    const [errores, setErrores] = useState({})

    useEffect(() => {
        getBancos();
        getDestinatarios();
        getMediosPago();
        getTipoCuentas();
        getParentescos();
    }, [])

    useEffect(() => {
        if (involucrado.rutDestinatario) {
            formik.setFieldValue('destinatarioPago.tipoDestinatario', involucrado?.destinatario);
            formik.setFieldValue('destinatarioPago.rut', involucrado?.rutDestinatario);
            formik.setFieldValue('destinatarioPago.nombre', involucrado?.nombre);
            formik.setFieldValue('destinatarioPago.email', involucrado?.email);
            formik.setFieldValue('destinatarioPago.medioPago', involucrado?.mdioPago);
            formik.setFieldValue('destinatarioPago.institucionFinanciera', involucrado.institucionFinanciera);
            formik.setFieldValue('destinatarioPago.tipoCuenta', involucrado?.tipoCuenta);
            formik.setFieldValue('destinatarioPago.numeroCuenta', involucrado?.nroCuenta);
        }
    }, [involucrado])

    const getBancos = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso })).toString('base64');
        const response = await serviceGetBancos(query);

        setBancos(response);
    }

    const getDestinatarios = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 260 })).toString('base64');
        const response = await serviceGetDetalle(query);

        setDestinatarios(response);
    }

    const getMediosPago = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 53 })).toString('base64');
        const response = await serviceGetDetalle(query);

        setMediosPago(response);
    }

    const getTipoCuentas = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 54 })).toString('base64');
        const response = await serviceGetDetalle(query);
        setTipoCuentas(response);
    }

    const getParentescos = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 310 })).toString('base64');
        const response = await serviceGetDetalle(query);
        setParentescos(response);
    }

    const mostrarCamposParentesco = destinatarios.some(d =>
        String(d.id) === String(formik.values.destinatarioPago.tipoDestinatario) &&
        Number(d.agrupacion) === 310
    );

    const formatFechaSiniestro = (fecha) => {
        if (!fecha) return "";
        const d = new Date(fecha);
        if (isNaN(d)) return fecha;
        return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;
    };

    const calcularEdad = (fechaNac, fechaSin) => {
        if (!fechaNac || !fechaSin) return "";
        const nac = new Date(fechaNac);
        const sin = new Date(fechaSin);
        if (isNaN(nac) || isNaN(sin)) return "";
        let edad = sin.getFullYear() - nac.getFullYear();
        const m = sin.getMonth() - nac.getMonth();
        if (m < 0 || (m === 0 && sin.getDate() < nac.getDate())) edad--;
        return edad >= 0 ? edad : "";
    };

    const existeRut = (rut) => {
        return destinatariosPago.some((d, index) => {
        if (editIndex !== null && index === editIndex) return false
        return d.rutDestinatario === rut
        })
    }
    const handleAgregarOEditar = () => {

        const erroresValidados = validarDestinatario()

        if (Object.keys(erroresValidados).length > 0) {
            setErrores(erroresValidados)
            return
        }

        setErrores({}) 

        const nuevo = {
            tipoDestinatario: formik.values.destinatarioPago.tipoDestinatario,
            rutDestinatario: formik.values.destinatarioPago.rut,
            nombreDestinatario: formik.values.destinatarioPago.nombre,
            emailDestinatario: formik.values.destinatarioPago.email,
            medioPago: formik.values.destinatarioPago.medioPago,
            institucion: formik.values.destinatarioPago.institucionFinanciera,
            tipoCuenta: formik.values.destinatarioPago.tipoCuenta,
            numeroCuenta: formik.values.destinatarioPago.numeroCuenta,
            montoPago: formik.values.destinatarioPago.montoPago.replace(/\./g, ''),
            parentesco: mostrarCamposParentesco ? formik.values.destinatarioPago.parentesco : "",
            fechaNacimiento: mostrarCamposParentesco ? formik.values.destinatarioPago.fechaNacimiento : "",
            edad: mostrarCamposParentesco ? calcularEdad(formik.values.destinatarioPago.fechaNacimiento, fechaSiniestro) : null
        }

        const esValidoMonto = validarMontoTotal(
            destinatariosPago,
            nuevo,
            montoTotalReserva,
            editIndex // null si es nuevo
        );

        if (!esValidoMonto) {
            setErrores({
                montoPago: `La suma de montos de pago no puede exceder el monto total reserva (${montoTotalReserva})`
            });
            return
        }

        if (editIndex !== null) {
            const copia = [...destinatariosPago]
            copia[editIndex] = nuevo
            setDestinatariosPago(copia)
            setEditIndex(null)
        } else {
            setDestinatariosPago([...destinatariosPago, nuevo])
        }

        limpiarFormulario()
    }
    const validarMontoTotal = (destinatariosPago, destinatarioActual, montoTotalReserva, editIndex = null) => {

        if (!montoTotalReserva) return true;

        let suma = 0;

        destinatariosPago.forEach((d, index) => {
            if (editIndex !== null && index === editIndex) return;
            suma += Number(d.montoPago || 0);
        });

        suma += Number(destinatarioActual.montoPago || 0);

        return suma <= Number(montoTotalReserva.replace(/\./g, ''));
    };
    const handleEditar = (row, index) => {
        setEditIndex(index)

        formik.setFieldValue('destinatarioPago.tipoDestinatario', row.tipoDestinatario);
        formik.setFieldValue('destinatarioPago.rut', row.rutDestinatario);
        formik.setFieldValue('destinatarioPago.nombre', row.nombreDestinatario);
        formik.setFieldValue('destinatarioPago.email', row.emailDestinatario);
        formik.setFieldValue('destinatarioPago.medioPago', row.medioPago);
        formik.setFieldValue('destinatarioPago.institucionFinanciera', row.institucion);
        formik.setFieldValue('destinatarioPago.tipoCuenta', row.tipoCuenta);
        formik.setFieldValue('destinatarioPago.numeroCuenta', row.numeroCuenta);
        formik.setFieldValue('destinatarioPago.montoPago', formato_monto(row.montoPago));
        formik.setFieldValue('destinatarioPago.parentesco', row.parentesco || "");
        formik.setFieldValue('destinatarioPago.fechaNacimiento', row.fechaNacimiento ? row.fechaNacimiento.substring(0, 10) : "");
    }
    const handleEliminar = (index) => {
      const copia = destinatariosPago.filter((_, i) => i !== index)
      setDestinatariosPago(copia)
    }
    const limpiarFormulario = () => {
        formik.setFieldValue('destinatarioPago', {
            tipoDestinatario: '',
            rut: '',
            nombre: '',
            email: '',
            medioPago: '',
            institucionFinanciera: '',
            tipoCuenta: '',
            numeroCuenta: '',
            montoPago: '',
            parentesco: '',
            fechaNacimiento: ''
        })

        setErrores({})
        setEditIndex(null)
    }
    
    const validarDestinatario = () => {
        const errores = {}
        const data = formik.values.destinatarioPago

        if (!data.tipoDestinatario) {
            errores.tipoDestinatario = 'Seleccione tipo destinatario'
        }
        if (!data.rut) {
            errores.rutDestinatario = 'Ingrese RUT'
        }
        if (!data.nombre) {
            errores.nombreDestinatario = 'Ingrese nombre'
        }
        if (!data.email) {
            errores.emailDestinatario = 'Ingrese email'
        } else {
            const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)
            if (!emailValido) {
            errores.emailDestinatario = 'Email inválido'
            }
        }
        if (!data.medioPago) {
            errores.medioPago = 'Seleccione medio de pago'
        }
        /*if (!data.institucionFinanciera) {
            errores.institucionFinanciera = 'Seleccione institución'
        }*/
        if (!data.tipoCuenta) {
            errores.tipoCuenta = 'Seleccione tipo de cuenta'
        }
        /*if (!data.numeroCuenta) {
            errores.numeroCuenta = 'Ingrese número de cuenta'
        }*/
        if (!data.montoPago || data.montoPago == 0) {
            errores.montoPago = 'Ingrese monto de pago'
        }
        if (existeRut(data.rut)) {
            errores.rutDestinatario = 'Este RUT ya fue agregado'
        }
        if (mostrarCamposParentesco && data.fechaNacimiento && fechaSiniestro &&
            new Date(data.fechaNacimiento) > new Date(fechaSiniestro)) {
            errores.fechaNacimiento = `Fecha de nacimiento no puede ser posterior a Fecha de Siniestro (${formatFechaSiniestro(fechaSiniestro)})`
        }
        return errores
    }
    const getNombreDestinatario = (id) => {
      return destinatarios?.find(
        c => String(c.id) === String(id)
      )?.nombre || id
    }

    return (
        <Fragment>
            <Card className='mt-1 '>
                <Container>
                    <Row>
                        <Col md='3'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-tipodest"]}
                            </Form.Label>
                            <br />
                            <Form.Select
                                name='destinatarioPago.tipoDestinatario'
                                onChange={(e) => { 
                                    formik.handleChange(e) 
                                    setErrores(prev => ({
                                        ...prev,
                                        tipoDestinatario: null
                                    }))
                                }}
                                value={formik.values.destinatarioPago.tipoDestinatario}>

                                <option value={''}>Seleccione...</option>
                                {destinatarios && destinatarios.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))}
                            </Form.Select>
                            {errores.tipoDestinatario && (
                                <Form.Text style={{ color: 'red' }}>
                                {errores.tipoDestinatario}
                                </Form.Text>
                            )}
                        </Col>
                        <Col md='3'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-rutdest"]}
                            </Form.Label>
                            <br />
                            <Form.Control
                                name='destinatarioPago.rut'
                                value={formik.values.destinatarioPago.rut}
                                onChange={(e) => { 
                                    formik.handleChange(e) 
                                    setErrores(prev => ({
                                        ...prev,
                                        rutDestinatario: null
                                    }))
                                }}
                                onBlur={(e) => { formik.handleBlur(e); formik.setFieldValue('destinatarioPago.rut', e.target.value) }}>
                            </Form.Control>
                            {formik.errors?.destinatarioPago?.rut && formik.touched?.destinatarioPago?.rut &&
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors?.destinatarioPago?.rut}
                                </Form.Text>
                            }
                            {errores.rutDestinatario && (
                                <Form.Text style={{ color: 'red' }}>
                                {errores.rutDestinatario}
                                </Form.Text>
                            )}

                        </Col>
                        <Col md='3'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-nomdest"]}
                            </Form.Label>
                            <br />
                            <Form.Control
                                name='destinatarioPago.nombre'
                                value={formik.values.destinatarioPago.nombre}
                                onChange={(e) => { 
                                    formik.handleChange(e) 
                                    setErrores(prev => ({
                                        ...prev,
                                        nombreDestinatario: null
                                    }))
                                }}>
                            </Form.Control>
                            {errores.nombreDestinatario && (
                                <Form.Text style={{ color: 'red' }}>
                                {errores.nombreDestinatario}
                                </Form.Text>
                            )}
                        </Col>
                        <Col md='3'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-emaildest"]}
                            </Form.Label>
                            <br />
                            <Form.Control
                                name='destinatarioPago.email'
                                value={formik.values.destinatarioPago.email}
                                onChange={(e) => { formik.handleChange(e) }}
                                onBlur={formik.handleBlur}>
                            </Form.Control>
                            {formik.errors?.destinatarioPago?.email && formik.touched?.destinatarioPago?.email &&
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors?.destinatarioPago?.email}
                                </Form.Text>
                            }
                            {errores.emailDestinatario && (
                                <Form.Text style={{ color: 'red' }}>
                                {errores.emailDestinatario}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        {mostrarCamposParentesco && (<>
                        <Col md='3' className='mt-2'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-parentesco"]}
                            </Form.Label>
                            <br />
                            <Form.Select
                                name='destinatarioPago.parentesco'
                                value={formik.values.destinatarioPago.parentesco}
                                onChange={formik.handleChange}>
                                <option value=''>Seleccione...</option>
                                {parentescos.map(p => (
                                    <option key={p.id} value={p.id}>{p.nombre}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md='3' className='mt-2'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-fechanac"]}
                            </Form.Label>
                            <br />
                            <Form.Control
                                type='date'
                                name='destinatarioPago.fechaNacimiento'
                                value={formik.values.destinatarioPago.fechaNacimiento}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    const fechaNac = e.target.value;
                                    if (fechaNac && fechaSiniestro && new Date(fechaNac) > new Date(fechaSiniestro)) {
                                        setErrores(prev => ({ ...prev, fechaNacimiento: `Fecha de nacimiento no puede ser posterior a Fecha de Siniestro (${formatFechaSiniestro(fechaSiniestro)})` }));
                                    } else {
                                        setErrores(prev => ({ ...prev, fechaNacimiento: null }));
                                    }
                                }}
                            />
                            {errores.fechaNacimiento && (
                                <Form.Text style={{ color: 'red' }}>{errores.fechaNacimiento}</Form.Text>
                            )}
                        </Col>
                        <Col md='2' className='mt-2'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-edad"]}
                            </Form.Label>
                            <br />
                            <Form.Control
                                readOnly
                                value={calcularEdad(formik.values.destinatarioPago.fechaNacimiento, fechaSiniestro)}
                                style={{ backgroundColor: '#e9ecef', cursor: 'default' }}
                            />
                        </Col>
                        </>)}
                    </Row>
                    <Row>
                        <Col className='mt-2'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-mediopagodest"]}
                            </Form.Label>
                            <br />
                            <Form.Select
                                name='destinatarioPago.medioPago'
                                value={formik.values.destinatarioPago.medioPago}
                                onChange={(e) => { 
                                    formik.handleChange(e) 
                                    setErrores(prev => ({
                                        ...prev,
                                        medioPago: null
                                    }))
                                }}>

                                <option value={''}>Seleccione...</option>
                                {mediosPago && mediosPago.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))}
                            </Form.Select>
                            {errores.medioPago && (
                                <Form.Text style={{ color: 'red' }}>
                                {errores.medioPago} 
                                </Form.Text>
                            )}
                        </Col>
                        <Col className='mt-2'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-instfinandest"]}
                            </Form.Label>
                            <br />
                            <Form.Select
                                name='destinatarioPago.institucionFinanciera'
                                value={formik.values.destinatarioPago.institucionFinanciera}
                                onChange={(e) => { 
                                    formik.handleChange(e) 
                                    setErrores(prev => ({
                                        ...prev,
                                        institucionFinanciera: null
                                    }))
                                }}>

                                <option value={''}>Seleccione...</option>
                                {bancos && bancos.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))}
                            </Form.Select>
                            {errores.institucionFinanciera && (
                                <Form.Text style={{ color: 'red' }}>
                                    {errores.institucionFinanciera}
                                </Form.Text>
                            )}
                        </Col>
                        <Col className='mt-2'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-tipoctadest"]}
                            </Form.Label>
                            <br />
                            <Form.Select
                                name='destinatarioPago.tipoCuenta'
                                value={formik.values.destinatarioPago.tipoCuenta}
                                onChange={(e) => { 
                                    formik.handleChange(e) 
                                    setErrores(prev => ({
                                        ...prev,
                                        tipoCuenta: null
                                    }))
                                }}>

                                <option value={''}>Seleccione...</option>
                                {tipoCuentas && tipoCuentas.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))}
                            </Form.Select>
                            {errores.tipoCuenta && (
                                <Form.Text style={{ color: 'red' }}>
                                    {errores.tipoCuenta}
                                </Form.Text>
                            )}
                        </Col>
                        <Col className='mt-2'>
                            <Form.Label className="label">
                                {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-nroctadest"]}
                            </Form.Label>
                            <br />
                            <Form.Control
                                name='destinatarioPago.numeroCuenta'
                                value={formik.values.destinatarioPago.numeroCuenta}
                                onChange={(e) => { 
                                    formik.handleChange(e) 
                                    setErrores(prev => ({
                                        ...prev,
                                        numeroCuenta: null
                                    }))
                                }}>
                            </Form.Control>
                            {errores.numeroCuenta && (
                                <Form.Text style={{ color: 'red' }}>
                                    {errores.numeroCuenta}  
                                </Form.Text>
                            )}
                        </Col>
                        <Col className='mt-2'>
                            <Form.Label className="label">
                                Monto Pago
                            </Form.Label>
                            <br />
                            <Form.Control
                                autoComplete='off'
                                name='destinatarioPago.montoPago'
                                value={formik.values.destinatarioPago.montoPago}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\./g, '')
                                    if (/^\d*$/.test(value)) {
                                        formik.setFieldValue('destinatarioPago.montoPago', value)
                                    }
                                    setErrores(prev => ({
                                        ...prev,
                                        montoPago: null
                                    }))
                                }}
                                onBlur={() => {
                                    const monto = formik.values.destinatarioPago.montoPago
                                    if (monto) {
                                        formik.setFieldValue('destinatarioPago.montoPago', formato_monto(monto))
                                    }
                                }}
                                onFocus={() => {
                                    const monto = formik.values.destinatarioPago.montoPago
                                    if (monto) {
                                        formik.setFieldValue('destinatarioPago.montoPago', monto.replace(/\./g, ''))
                                    }
                                }}
                            />
                            {errores.montoPago && (
                                <Form.Text style={{ color: 'red' }}>
                                {errores.montoPago}
                                </Form.Text>
                            )}
                            </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col className='d-flex justify-content-end gap-2'>
                            {editIndex !== null && (
                                <Button size='sm' variant='outline-secondary' onClick={limpiarFormulario}>
                                    Cancelar
                                </Button>
                            )}
                            <Button
                                size='sm'
                                variant={editIndex !== null ? 'outline-success' : 'outline-primary'}
                                onClick={handleAgregarOEditar}
                            >
                                {editIndex !== null ? 'Actualizar destinatario' : 'Agregar destinatario'}
                            </Button>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col>
                        <Table striped hover className="table destinatarios-table">
                            <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Rut</th>
                                <th>Nombre</th>
                                <th>Email</th>
                                <th>Monto</th>
                                <th style={{ textAlign: 'center', width: '8%' }}>Acciones</th>
                            </tr>
                            </thead>

                            <tbody>
                            {destinatariosPago.length === 0 ? (
                                <tr>
                                <td colSpan="6" className="text-center">
                                    Sin destinatarios
                                </td>
                                </tr>
                            ) : (
                                destinatariosPago.map((row, index) => (
                                <tr key={index}>
                                    <td>{getNombreDestinatario(row.tipoDestinatario)}</td>
                                    <td>{row.rutDestinatario}</td>
                                    <td>{row.nombreDestinatario}</td>
                                    <td>{row.emailDestinatario}</td>
                                    <td>{formato_monto(row.montoPago)}</td>

                                    <td className="text-center">                              
                                    <FaEdit className='icon'
                                        size={20}
                                        color='gray'
                                        title="Modificar Destinatario"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleEditar(row, index)}
                                    />
                                    <FaTrashAlt className='icon'
                                        size={20}
                                        color='gray'
                                        title="Eliminar Destinatario"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleEliminar(index)}
                                    />
                                    </td>
                                </tr>
                                ))
                            )}
                            </tbody>
                        </Table>
                        </Col>
                    </Row>
                </Container>
            </Card>

            <style type='text/css'>
                {`
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .is_required:after {
                        content: "*";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .destinatarios-table thead th {
                        background-color: #4F517A;
                        color: white;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default DestinatarioPago;